import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Text,
} from "@fluentui/react-components";
import { makeStyles } from "@fluentui/react-components";
import designTokens from "../../../../theme/customTheme";
import { IHowDiagnosticsWorkDialogProps } from "./howDiagnosticsWorkDialog.types";

const useStyles = makeStyles({
  dialogSurface: {
    "@media (max-width: 640px)": {
      minWidth: "unset",
      width: "calc(100vw - 32px)",
      maxWidth: "100%",
    },
  },
  list: {
    paddingLeft: designTokens.spacing[5],
    margin: 0,
  },
  listItem: {
    marginBottom: designTokens.spacing[2],
  },
});

export const HowDiagnosticsWorkDialog = (
  props: IHowDiagnosticsWorkDialogProps,
): JSX.Element => {
  const { open, onClose } = props;
  const styles = useStyles();

  const steps = [
    "Create a diagnostic with details.",
    "Add objectives — questions are auto-generated.",
    "Review & edit questions.",
    "Create a distribution and invite participants.",
    "Monitor responses and export results.",
  ];

  return (
    <Dialog open={open} modalType="alert">
      <DialogSurface className={styles.dialogSurface}>
        <DialogBody>
          <DialogTitle>How diagnostics work</DialogTitle>
          <DialogContent>
            <Text size={300}>
              <ol className={styles.list}>
                {steps.map((step, i) => (
                  <li key={i} className={styles.listItem}>
                    {step}
                  </li>
                ))}
              </ol>
            </Text>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onClose}>
              Got it
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
